exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.card-container[data-v-607c5852]{margin:20px;border-radius:10px\n}\n", "", {"version":3,"sources":["/builds/youx-group/sicarf/sicarf-parametrizavel/frontend/src/screens/analise/listagem/ProcessosAnalisadosListagem.vue"],"names":[],"mappings":";AAkDA,iCACE,YACA,kBAAmB;CACpB","file":"ProcessosAnalisadosListagem.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.card-container {\n  margin: 20px;\n  border-radius: 10px;\n}\n\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-607c5852","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/screens/analise/listagem/ProcessosAnalisadosListagem.vue
// module id = bWEj
// module chunks = 12